import { clsx } from "clsx";
import { useCallback } from "react";
import LoadingText from "../../../../externalComponents/LoadingText";
import {
  Description,
  Field,
  Fieldset,
  Label,
} from "../../../../externalComponents/tailwind/fieldset";
import {
  Radio,
  RadioField,
  RadioGroup,
} from "../../../../externalComponents/tailwind/radio";
import { Text } from "../../../../externalComponents/tailwind/text";
import { stepCampaignEnum } from "./send-campaign-step.enum";

const SendCampaignOptions = ({
  className,
  expanded,
  form,
  setForm,
  setModalRef,
}) => {
  const updateOnlyOptins = useCallback(
    (sendOnlyToOptins) => {
      const step = stepCampaignEnum.scheduleSending;
      // For all segment types (Klaviyo, Shopify, Hubspot, Simio Segment), use breakdown data
      setForm((_form) => {
        const { optins, notOptouts } = _form.contactsBreakdown || {
          optins: [],
          notOptouts: [],
        };
        const _contacts = sendOnlyToOptins ? optins : notOptouts;
        return {
          ..._form,
          sendOnlyToOptins,
          stepToFill: _form.stepToFill < step ? step : _form.stepToFill,
          expanded: new Set(_form.expanded).add(step),
          pacing: {
            ..._form.pacing,
            effectiveSelectedContacts: _contacts || [],
          },
        };
      });
    },
    [form.sendOnlyToOptins, form.type],
  );

  const showDetails = useCallback(({ contactsBreakdownMode, event }) => {
    event.stopPropagation();
    setModalRef((_modalRef) => {
      return { ..._modalRef, contactsBreakdownMode };
    });
  });

  return (
    <>
      <Field
        className={clsx(
          "border rounded-customBorderRadius p-3 mt-5",
          className,
        )}
      >
        <Text className="font-bold">2. Sending mode</Text>
        {expanded && (
          <Fieldset className="mt-5">
            <RadioGroup
              name="only_optin"
              defaultValue={null}
              onChange={(checked) => updateOnlyOptins(checked)}
            >
              <RadioField>
                <Radio value={true} />
                <Label>
                  <span>
                    Send only to the segment's contacts that are also optin in
                    Simio&nbsp;
                    {form.fetchingContactsBreakdown ? (
                      <span className="inline-block w-[50px] relative top-[5px]">
                        <LoadingText />
                      </span>
                    ) : form.contactsBreakdown?.optins?.length ? (
                      <span
                        className="text-base/6 text-zinc-500 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-zinc-400 hover:underline hover:cursor-pointer"
                        onClick={(event) =>
                          showDetails({ contactsBreakdownMode: 1, event })
                        }
                      >
                        ( {form.contactsBreakdown.optins.length} )
                      </span>
                    ) : null}
                  </span>
                </Label>
              </RadioField>
              <RadioField>
                <Radio value={false} />
                <Label>
                  <span>
                    Send to all segment's contacts, unless they explicitly opted
                    out&nbsp;
                    {form.fetchingContactsBreakdown ? (
                      <span className="inline-block w-[50px] relative top-[5px]">
                        <LoadingText />
                      </span>
                    ) : form.contactsBreakdown?.notOptouts?.length ? (
                      <span
                        className="text-base/6 text-zinc-500 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-zinc-400 hover:underline hover:cursor-pointer"
                        onClick={(event) =>
                          showDetails({ contactsBreakdownMode: 2, event })
                        }
                      >
                        ( {form.contactsBreakdown.notOptouts.length} )
                      </span>
                    ) : null}
                  </span>
                </Label>
                <Description>
                  <strong>WARNING</strong>: Use with caution and make sure you
                  have the right to reach these contacts
                </Description>
              </RadioField>
            </RadioGroup>
          </Fieldset>
        )}
      </Field>
    </>
  );
};

export default SendCampaignOptions;
